<template>
	<v-container grid-list-md>
		<v-layout row wrap>
			<v-flex xs12 md8>
				<v-layout row wrap>
					<v-flex xs12>
						<ValidationProvider name="title" rules="required" v-slot="{ errors }">
							<v-text-field v-model="item.title" :label="$t('Title')" :error-messages="errors"></v-text-field>
						</ValidationProvider>
					</v-flex>
					<v-flex xs12>
						<ValidationProvider name="button_text" v-slot="{ errors }">
							<v-text-field v-model="item.button_text" :label="$t('Button Text')" :error-messages="errors"></v-text-field>
						</ValidationProvider>
					</v-flex>

					<v-flex xs12>
						<ValidationProvider name="button_url" v-slot="{ errors }">
							<v-text-field v-model="item.button_url" :label="$t('Button Link')" :error-messages="errors"></v-text-field>
						</ValidationProvider>
					</v-flex>

					<v-flex xs12 md6>
						<ValidationProvider name="start_date" v-slot="{ errors }">
							<v-text-field type="date" v-model="item.start_date" :label="$t('Start Date')" :error-messages="errors"></v-text-field>
						</ValidationProvider>
					</v-flex>

					<v-flex xs12 md6>
						<ValidationProvider name="end_date" v-slot="{ errors }">
							<v-text-field type="date" v-model="item.end_date" :label="$t('End Date')" :error-messages="errors"></v-text-field>
						</ValidationProvider>
					</v-flex>

					<v-flex xs12>
						<ValidationProvider name="description" v-slot="{ errors }">
							<v-textarea v-model="item.description" :label="$t('Description')" :error-messages="errors"></v-textarea>
						</ValidationProvider>
					</v-flex>
				</v-layout>
			</v-flex>
			<v-flex xs12 md4 class="pl-10">
				<v-layout row wrap>
					<v-flex xs12>
						<v-card>
							<v-card-title primary-title>
								<h3>{{ $t("Cover Image") }}</h3>
							</v-card-title>
							<v-divider></v-divider>
							<v-card-text>
								<app-media-library v-model="item.image"></app-media-library>
							</v-card-text>
						</v-card>
					</v-flex>

				</v-layout>
			</v-flex>

		</v-layout>
	</v-container>
</template>

<script>
	export default {
		props: ["value", "locations"],
		computed: {
			item: {
				get() {
					return this.value;
				},
				set(value) {
					this.$emit("input", value);
				},
			},
		},
	};
</script>